export default "__VITE_ASSET__DSktga6q__"